/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const getContentSharingResponseDataGrantsItemPermissionMaskMin = 0;
export const getContentSharingResponseDataGrantsItemPermissionMaskMax = 63;

export const getContentSharingResponseDataLinksItemPermissionMaskMin = 0;
export const getContentSharingResponseDataLinksItemPermissionMaskMax = 63;

export const GetContentSharingResponse = zod.object({
  data: zod.object({
    contentUuid: zod.uuid().describe('The head version the roster was read on.'),
    grants: zod
      .array(
        zod.object({
          actor: zod
            .object({
              actorType: zod.enum(['USER', 'SYSTEM', 'GROUP', 'PUBLIC', 'AGENT']),
              firstName: zod.string().nullable(),
              id: zod.string().nullable(),
              lastName: zod.string().nullable(),
              name: zod.string(),
              profileImage: zod
                .object({
                  large: zod
                    .object({
                      contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
                      url: zod.string().nullable(),
                    })
                    .nullable(),
                  medium: zod
                    .object({
                      contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
                      url: zod.string().nullable(),
                    })
                    .nullable(),
                  original: zod
                    .object({
                      contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
                      url: zod.string().nullable(),
                    })
                    .nullable(),
                  small: zod
                    .object({
                      contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
                      url: zod.string().nullable(),
                    })
                    .nullable(),
                  xsmall: zod
                    .object({
                      contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
                      url: zod.string().nullable(),
                    })
                    .nullable(),
                })
                .nullable(),
              uuid: zod.uuid().describe('UUID v4 identifier'),
            })
            .and(
              zod
                .object({
                  email: zod
                    .string()
                    .nullable()
                    .describe(
                      'For a USER actor, their email, as getContentSharing gives it. Null for every other actor.',
                    ),
                })
                .nullable(),
            )
            .describe(
              'The principal’s display side. Null when it no longer resolves to an actor; the row can still be revoked.',
            ),
          edgeType: zod
            .enum(['AUTHORED_BY', 'SHARED_WITH'])
            .describe(
              'AUTHORED_BY: wrote this version (provenance: what it allows is the mask, which a lowered share can reduce). SHARED_WITH: shared.',
            ),
          expiresAt: zod
            .string()
            .nullable()
            .describe(
              'When the access ends (checked by calendar day); null for no expiry. An expired row is still listed, as getContentSharing lists it, and grants nothing.',
            ),
          permissionMask: zod
            .int()
            .min(getContentSharingResponseDataGrantsItemPermissionMaskMin)
            .max(getContentSharingResponseDataGrantsItemPermissionMaskMax)
            .describe(
              'The stored mask: READ 1, SHARE 2, COPY 4, CONTRIBUTE 8, EDIT 16, DELETE 32.',
            ),
          permissions: zod
            .array(zod.enum(['READ', 'SHARE', 'COPY', 'CONTRIBUTE', 'EDIT', 'DELETE']))
            .describe('The permissions in the mask, in ladder order.'),
          principalType: zod
            .enum(['USER', 'GROUP', 'GROUP_MEMBERS', 'GROUP_MEMBER', 'PUBLIC', 'SYSTEM', 'AGENT'])
            .describe(
              'Who the row is for, as stored: USER (a person), GROUP (the group acting as itself), GROUP_MEMBERS (everyone in the group), GROUP_MEMBER (a person acting in the group in scopeUuid), PUBLIC (everyone), AGENT or SYSTEM.',
            ),
          principalUuid: zod
            .uuid()
            .describe(
              'The user, group, agent or system actor; for PUBLIC, the PUBLIC actor. POST \/content\/share names PUBLIC without one.',
            ),
          scopeUuid: zod
            .uuid()
            .nullable()
            .describe(
              'The group a GROUP_MEMBER row acts in, or the user an AGENT row acts for. Null otherwise.',
            ),
        }),
      )
      .describe(
        'One row per access row on the head: its authors first, then its shares. Nothing inherited from ancestors, nothing below the head.',
      ),
    lineageUuid: zod.uuid().describe('UUID v4 identifier'),
    links: zod
      .array(
        zod.object({
          challengeLabel: zod.string().nullable(),
          createdAt: zod.string(),
          expiresAt: zod.string().nullable(),
          grantType: zod.enum(['LINK']),
          grantUuid: zod.uuid().describe('UUID v4 identifier'),
          hasPin: zod.boolean(),
          permissionMask: zod
            .int()
            .min(getContentSharingResponseDataLinksItemPermissionMaskMin)
            .max(getContentSharingResponseDataLinksItemPermissionMaskMax),
          permissions: zod.array(
            zod.enum(['READ', 'SHARE', 'COPY', 'CONTRIBUTE', 'EDIT', 'DELETE']),
          ),
          slug: zod.string().nullable(),
        }),
      )
      .describe('Share links. Empty unless the caller also holds SHARE, as in getContentSharing.'),
  }),
});

export type GetContentSharingResponse = zod.input<typeof GetContentSharingResponse>;
export type GetContentSharingResponseOutput = zod.output<typeof GetContentSharingResponse>;
